import React from 'react';

const FILTER_LABELS = {
  all: 'All',
  weak: 'Needs work',
  untouched: 'Not started',
  moderate: 'Moderate',
  strong: 'Strong',
};

export default function TopicFilters({
  filter,
  onFilterChange,
  counts,
  view,
  onViewChange,
  search,
  onSearchChange,
  subjects,
  activeSubject,
  onSubjectChange,
  moduleLabel,
}) {
  return (
    <>
      {/* Subject tabs (L1) */}
      <div className="tv3-subject-tabs">
        <span
          className={`tv3-subject-tab${activeSubject == null ? ' active' : ''}`}
          onClick={() => onSubjectChange(null)}
        >
          {moduleLabel}
        </span>
        {subjects.map(s => (
          <span
            key={s}
            className={`tv3-subject-tab${activeSubject === s ? ' active' : ''}`}
            onClick={() => onSubjectChange(s)}
          >
            {s}
          </span>
        ))}
      </div>

      <input
        className="tv3-search"
        type="text"
        placeholder="Search topics, areas, keywords"
        value={search}
        onChange={e => onSearchChange(e.target.value)}
      />

      <div className="tv3-top-bar">
        <div className="tv3-filter-pills">
          {['all', 'weak', 'untouched', 'moderate', 'strong'].map(key => {
            if (counts[key] == null) return null;
            return (
              <span
                key={key}
                className={`tv3-pill${filter === key ? ' active' : ''}`}
                onClick={() => onFilterChange(key)}
              >
                {FILTER_LABELS[key]} {counts[key]}
              </span>
            );
          })}
        </div>
        <div className="tv3-view-toggle">
          <button
            className={view === 'study_units' ? 'active' : ''}
            onClick={() => onViewChange('study_units')}
          >
            Study units
          </button>
          <button
            className={view === 'subtopics' ? 'active' : ''}
            onClick={() => onViewChange('subtopics')}
          >
            Detailed subtopics
          </button>
        </div>
      </div>
    </>
  );
}
